// FT-009: единый платёжный код CloudPayments для in-LMS покупки полного курса free/demo Academy.
// Заменяет per-company window.payWithUserPayload из company.js_code: логика одна на все курсы,
// различается только slug продукта (см. memory-bank/features/FT-009/design.md SOL-04/SD-01/CTR-02/CTR-03).

const WIDGET_SRC = 'https://widget.cloudpayments.ru/bundles/cloudpayments.js';
const PRICES_URL = 'https://assets.eduson.academy/prices_api/prices.json';
const SUCCESS_URL = 'https://eduson.academy/payment-success';
const ERROR_URL = 'https://eduson.academy/payment-error';

let widgetPromise = null;
let pricesPromise = null;

// Лениво подгружает скрипт виджета CloudPayments один раз (EXT-01).
function loadWidget() {
	if (window.cp && window.cp.CloudPayments) return Promise.resolve();
	if (widgetPromise) return widgetPromise;

	widgetPromise = new Promise((resolve, reject) => {
		const script = document.createElement('script');
		script.src = WIDGET_SRC;
		script.async = true;
		script.onload = resolve;
		script.onerror = () => {
			widgetPromise = null;
			reject(new Error('CloudPayments widget failed to load'));
		};
		document.head.appendChild(script);
	});

	return widgetPromise;
}

// Тянет prices.json один раз за сессию и кэширует промис (CTR-03).
function loadPrices() {
	if (pricesPromise) return pricesPromise;

	pricesPromise = fetch(PRICES_URL, { credentials: 'omit' })
		.then((response) => (response.ok ? response.json() : Promise.reject(new Error('prices.json HTTP ' + response.status))))
		.catch((error) => {
			pricesPromise = null;
			return Promise.reject(error);
		});

	return pricesPromise;
}

// Резолвит данные продукта по slug из prices.json (CTR-03) для продающего блока в LMS.
// Возвращает объект продукта (course_name, product_description, цены/рассрочка) либо null,
// если prices.json недоступен или продукта нет — вызывающий код деградирует мягко.
export async function loadProduct(productSlug) {
	if (!productSlug) return null;

	try {
		const prices = await loadPrices();
		return prices[productSlug] || null;
	} catch (error) {
		return null;
	}
}

// Открывает виджет оплаты (рассрочка ТБанк / карты / СБП / TPay) для продукта по slug.
// Цена и данные продукта резолвятся из prices.json (CTR-03); payload — только attribution-набор,
// без карт/секретов (CTR-02/INV-04). Возвращает { ok: true } при старте оплаты либо
// { ok: false, reason } для fallback на консультацию (FM-02).
export default async function payWithUserPayload({ publicId, productSlug, attribution = {}, payMode = 'installment' }) {
	if (!publicId) return { ok: false, reason: 'no_public_id' };
	if (!productSlug) return { ok: false, reason: 'no_slug' };

	let product;
	try {
		const prices = await loadPrices();
		product = prices[productSlug];
	} catch (error) {
		return { ok: false, reason: 'prices_unavailable' };
	}
	if (!product) return { ok: false, reason: 'no_product' };

	try {
		await loadWidget();
	} catch (error) {
		return { ok: false, reason: 'widget_unavailable' };
	}

	const config = {
		publicId,
		description: product.course_name,
		amount: product.full_discounted_price,
		currency: 'RUB',
		accountId: 'lms_id_' + attribution.user_id,
		email: attribution.email,
		invoiceId: productSlug + '-' + Date.now(),
		data: {
			...attribution,
			product_id: product.product_id,
			// CTR-02: маркер системы-источника покупки — оплата инициирована из LMS
			// (в отличие от source_surface, который указывает конкретную поверхность внутри LMS)
			source: 'lms',
			// выбранный режим оплаты (installment / full) — для аналитики и обработки в n8n
			pay_mode: payMode
		}
	};

	const widget = new window.cp.CloudPayments();
	widget.pay('charge', config, {
		onSuccess() {
			window.location.assign(SUCCESS_URL);
		},
		onFail() {
			window.location.assign(ERROR_URL);
		}
	});

	return { ok: true };
}
